export const environment = {
  production: true,
  bookingServerUrl: 'https://admin.bokasalasparbank.se/booking-server',
  clientId: 'booking-ssb',
  clientSecret: 'xXX1*zzW^rm$',
  hideHelp: true
};
